import { isProduction, appEnv } from '@/lib/env';

/**
 * Thin warning bar shown on every non-production environment per
 * CLAUDE.md §9 / §13 — so a merchant (or us) never mistakes staging
 * for the live store. Renders nothing in production.
 */
export function TestModeBanner() {
  if (isProduction()) return null;
  return (
    <div
      role="status"
      className="w-full bg-amber-100 px-4 py-1.5 text-center text-xs font-medium text-amber-900 dark:bg-amber-950 dark:text-amber-200"
    >
      Test mode — you&apos;re on <span className="font-semibold">{appEnv()}</span>. Data and labels
      here aren&apos;t real.
    </div>
  );
}
